import { Client } from "@stomp/stompjs";
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from "react";
import SockJS from "sockjs-client";
import { Constant } from "../../../constant";
import { NormalAlert } from "../../../export/AlertMessage";
import Service, { url } from "../../../service";
import ListGps from "../Map/ListGps";
import MapComponent from "../Map/MapComponent";
import PetitDetailGps from "../Map/PetitDetailGps";
import AjoutModal from "./AjoutModal";

let user = JSON.parse(localStorage.getItem('user'));

export default function MesGPS(props) {
  const [donnesList, setDonneesList] = useState([]);
  const [ajoutModal, setAjoutModal] = useState({visibilite: false, data: {}});
  const [spinner, setSpinner] = useState(false);
  const [petitDetailModal, setPetitDetailModal] = useState({visibilite: false, data: {}});
  const [zoomerActionData, setZoomerActionData] = useState({});

  useEffect(() => {
    getLastGPSPostion()
  }, []);

  useEffect(() => {
    if(petitDetailModal.visibilite){
      let d = donnesList.filter(a=> a.gps.id === petitDetailModal.data.gps.id)[0]
      setPetitDetailModal({...petitDetailModal, visibilite: true, data: d})
    }
  }, [donnesList]);

  const startWebSocket = () => {
    const client = new Client({
      webSocketFactory: () =>
        new SockJS(
            url + "/ws?token=" +
            localStorage.getItem(Constant.tokenLocal)
        ),
      debug: (str) => {},
      reconnectDelay: 5000,
    });

    client.onConnect = () => {

      // ⚡ Abonnement à la destination utilisateur
      // client.subscribe("/topic/test", (message) => {
      client.subscribe("/user/topic/gps", (message) => {
        const newDataArray = JSON.parse(message.body);
        const updates = Array.isArray(newDataArray) ? newDataArray : [newDataArray];
        setDonneesList(prevList => updateGpsDataBatch(prevList, updates));

        // Rafraîchir la carte / les marqueurs une seule fois
        // updateMapMarkers(gpsDataList);
      });
    };

    client.onStompError = (frame) => {
    };

    client.activate();

    return () => client.deactivate();
  }
  const getLastGPSPostion = () => {
      setSpinner(true);
          Service.getAll(Constant.paths.gpsLastPositionData, {}, true).then(
            async (reponse) => {
              setSpinner(false);
              if(reponse.status === 200 || reponse.status === 201){
                setDonneesList(reponse.data.data)
                startWebSocket()
              }
              
            }, error => {
                setSpinner(false);
                if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                  NormalAlert("error", error.response.data.message);
              } else {
                  NormalAlert("error", Constant.fr.erreurServeur);
              }
            }
          )
    };

function updateGpsDataBatch(gpsDataList, newDataArray) {
    // Créer un Map des anciennes données pour un accès rapide
      const oldMap = new Map(gpsDataList.map(d => [d.imei, d]));

      // Mettre à jour seulement ce qui a changé
      newDataArray.forEach(newData => {
        const oldData = oldMap.get(newData.imei);
        if (!oldData || JSON.stringify(oldData) !== JSON.stringify(newData)) {
          oldMap.set(newData.imei, newData); // remplacer si nouveau ou modifié
        }
        // sinon, on garde l'ancienne référence pour éviter un rerender
      });

      return Array.from(oldMap.values());
    }

    const retourModal = (data, type) => {
      if (type === 0) {
        // Ajouter
        setDonneesList(prev => [...prev, {gps: data}]);
      }

      else if (type === 1) {
        // Modifier (par exemple avec id ou imei)
        setDonneesList(prev =>
          prev.map(item =>
            item.gps.id === data.gps.id ? data : item
          )
        );
      }

      else if (type === 2) {
        // Supprimer
        setDonneesList(prev =>
          prev.filter(item => item.gps.imei !== data.gps.imei)
        );
      }
      
    }

  const openAjoutModal = (data) => {
    setAjoutModal({...ajoutModal, visibilite: true, data: data})
  }

  const openPetitDetail = (data) => {
    setZoomerActionData(data)
    setPetitDetailModal({...petitDetailModal, visibilite: true, data: data})
  }

  const closeAjoutModal = () => {
    setAjoutModal({...ajoutModal, visibilite: false, data: {}})
  }
  const closePetitDetailModal = () => {
    setPetitDetailModal({...petitDetailModal, visibilite: false, data: {}})
  }
  
  return (
    <div style={{ position: "relative", height: "100vh", width: "100%" }}>
      <MapComponent gpsDataList={donnesList} openPetitDetail={openPetitDetail.bind()} zoomerActionData={zoomerActionData}/>
      {/* Pour la liste des gps */}
      <ListGps gpsDataList={donnesList} retourModal={retourModal.bind()} openPetitDetail={openPetitDetail.bind()} openAjoutModal={openAjoutModal.bind()}/>
      {ajoutModal.visibilite &&
        <AjoutModal details={ajoutModal} close={closeAjoutModal.bind()} retourModal={retourModal.bind()}/>
      }
      {petitDetailModal.visibilite &&
        <PetitDetailGps details={petitDetailModal} close={closePetitDetailModal.bind()} retourModal={retourModal.bind()} openAjoutModal={openAjoutModal.bind()}/>
      }
    </div>
  );
}
